import {
  CONDUCTOR_COOKIE_NAME,
  conductorServedByV2,
  isConductorPath,
} from "~/helpers/conductorSwitch";

export default function ({ app, route, from, $config, redirect }) {
  if (process.server || !isConductorPath(route.path)) {
    return;
  }
  // The first client render of a page the server did not render has from === route: never bounce it.
  if (!from || from.fullPath === route.fullPath) {
    return;
  }
  if (
    !conductorServedByV2(
      $config.conductorSwitch,
      app.$cookie.get(CONDUCTOR_COOKIE_NAME)
    )
  ) {
    return;
  }
  redirect(`${window.location.origin}${route.fullPath}`);
}
